import { Review } from '../../shared/models/review.model';


/**
 * Business review/rating model
 */
export class BusinessReview extends Review {
  /**
   * Business record ID for which this record applies
   */
  businessId: number;

  /**
   * Parses review
   * @param data {any} Review data as returned by API
   * @return {AirportReview} Parsed review
   */
  static parse(data: any): BusinessReview {
    const review = Review.parse(data) as BusinessReview;
    review.businessId = data.businessId;
    return review;
  }
}
